module.exports = __webpack_public_path__ + "static/media/8OLA10.6563e71c.jpg";